import React from "react";
import { Modal, Button } from "@themesberg/react-bootstrap";
import "./index.module.css";

export const GlobalModal = ({
  isOpen,
  title = "Create Item",
  onClose,
  children,
  size = "xl",
}) => {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      className="custom-modal"
      size={size}
      scrollable={true}
      backdrop="static"
      animation={false}
    >
      <Modal.Header>
        <Modal.Title className="h4">{title}</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={onClose} />
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};
